import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Strict 50/page server-side paginator (page size is hard-capped at 50 by
 * the backend `paginate()` helper; this UI just walks page numbers).
 */
const Pagination = ({ page, totalPages, total, onChange }) => {
  if (!totalPages || totalPages <= 1) {
    return (
      <div className="flex items-center justify-between text-[11px] uppercase tracking-[0.18em] text-[var(--sc-text-mute)] mt-4">
        <span data-testid="pagination-info">
          {total ?? 0} {(total ?? 0) === 1 ? 'record' : 'records'} · 50 / page
        </span>
        <span>page 1 / 1</span>
      </div>
    );
  }
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mt-5">
      <div className="text-[11px] uppercase tracking-[0.18em] text-[var(--sc-text-mute)]">
        <span data-testid="pagination-info">
          {total} records · 50 / page · page {page} / {totalPages}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onChange(Math.max(1, page - 1))}
          disabled={page <= 1}
          className="inline-flex items-center gap-1 px-3 py-2 rounded-lg border border-[rgba(255,182,18,0.32)] text-[12px] text-[#FFC20E] disabled:opacity-30 disabled:cursor-not-allowed hover:bg-[rgba(255,182,18,0.05)] transition"
          data-testid="pagination-prev"
        >
          <ChevronLeft className="w-3.5 h-3.5" />
          Prev
        </button>
        <button
          type="button"
          onClick={() => onChange(Math.min(totalPages, page + 1))}
          disabled={page >= totalPages}
          className="inline-flex items-center gap-1 px-3 py-2 rounded-lg border border-[rgba(255,182,18,0.32)] text-[12px] text-[#FFC20E] disabled:opacity-30 disabled:cursor-not-allowed hover:bg-[rgba(255,182,18,0.05)] transition"
          data-testid="pagination-next"
        >
          Next
          <ChevronRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
